import React  from "react"
import Menu from "./menu"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { IButton, ILink, IMenuItem, INavigationBar } from "../../../gatsby-graphql"
import {
  NavBarInner,
  NavBarWrapper,
  Row,
  ButtonsWrapper,
} from "./nav-bar-elements"
import { LogoImgStyle, LogoStyle } from "./nav-bar-styles"
import { Button } from "../../ui"
import { ButtonType } from "../../ui/button/button-elements"
import { shouldShowRegistrationButton, RegistrationButton } from "./special-button"

interface NavBarProps {
  data: INavigationBar
  locale?: string
}

function determineButton(button: IButton, index: number, locale?: string) {
  if (shouldShowRegistrationButton(button?.link?.url)) {
    return <RegistrationButton button={button} key={index}/>;
  } else {
    return <Button
      link={button?.link as ILink}
      type={button?.type as ButtonType}
      textTransform="uppercase"
      locale={locale}
      key={index}
    />
  }
}

const NavBar = ({ data, locale }: NavBarProps) => {
  return (
    <NavBarWrapper>
      <NavBarInner>
        <Row>
          <Link to={`/${data.locale || "en"}/`} hrefLang={locale}>
            {data.logo && <GatsbyImage
              image={data.logo?.localFile?.childImageSharp?.gatsbyImageData}
              imgStyle={LogoImgStyle}
              style={LogoStyle}
              alt="logo"
            />}
          </Link>
          <Menu items={data.mainMenu as IMenuItem[]} locale={locale} />
        </Row>
        {data.buttons && data.buttons.length > 0 && (
          <ButtonsWrapper>
            {data.buttons.map((button, index) => (determineButton(button!, index, locale)))}
          </ButtonsWrapper>
        )}
      </NavBarInner>
    </NavBarWrapper>
  )
}

export default NavBar
